import { createContext, useContext } from "react"

const ExtrasAndContradictionsContext = createContext({})

export const useExtrasAndContradictionsContext = () =>
  useContext(ExtrasAndContradictionsContext)

export default ExtrasAndContradictionsContext
